export const EDIT_PATIENT_PROFILE_DETAILS = {
  FIRST_NAME: "patientFirstName",
  LAST_NAME: "patientLastName",
  EMAIL: "patientEmail",
  CONTACT_NUMBER: "patientNumber",
  BSA_ID: "patientBSAId",
  DATE_OF_BIRTH: "BirthDate",
  JAMBOREE_UNIT_NUMBER: "Unit-Number",
  JAMBOREE_UNIT_LEADER_NAME: "Unit-Leader-Name",
  JAMBOREE_UNIT_LEADER_EMAIL: "Unit-Leader-Email",
  CLINIC_LOCATION: "clinicLocation",
};
